import api from "./index";

export async function getPromotionsAvailable(params) {
  return api.get("/promotions/available", { params });
}
